import React, { useState } from 'react';
import ReactMarkdown from "react-markdown"
import "./StaticPageContent.scss"
import { Container, Row, Col } from "react-bootstrap"
import Dataloft from '../Dataloft/Dataloft';
import HTMLReactParser from 'html-react-parser'
import { useLocation } from '@reach/router';

const StaticPageContent = (props) => {

    const DataloftArray = ['/sales-thame/', '/sales-crendon/', '/sales-haddenham/', '/sales-oxford/', '/lettings-thame/', '/lettings-crendon/', '/lettings-haddenham/', '/lettings-oxford/', '/prime-market-thame/', '/prime-market-oxford/'];
    
    var { pathname } = useLocation();

    const isActivity = DataloftArray.includes(pathname)
    return (
        <div className={"static-page-block"}>
            <Container>
                <Row>
                    {isActivity ? 
                    <Col lg={12}>
                        <Dataloft src={HTMLReactParser(props?.Content)} />
                    </Col>
                    :
                    <Col lg={12}>
                        <h1>{props.Title}</h1>
                        <div className="st-page"><ReactMarkdown source={props?.Content} allowDangerousHtml /></div>
                    </Col>}
                </Row>
            </Container>
        </div>
    );
}


export default StaticPageContent;